import type {
  GetQueueJobsResponse,
  GetQueuesResponse,
  JobState,
  QueueAction,
} from "../types/queue-types";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/internal/queues`;

type ActionResponse = {
  success: boolean;
  message: string;
};

export const getQueues = async (): Promise<GetQueuesResponse> => {
  const response = await fetch(BASE_URL, {
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch queues: ${response.statusText}`);
  }

  return response.json() as Promise<GetQueuesResponse>;
};

export const getQueueJobs = async (
  queueName: string,
  state: JobState,
  limit: number,
  offset: number,
): Promise<GetQueueJobsResponse> => {
  const params = new URLSearchParams({
    state,
    limit: String(limit),
    offset: String(offset),
  });

  const response = await fetch(`${BASE_URL}/${queueName}/jobs?${params}`, {
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch jobs: ${response.statusText}`);
  }

  return response.json() as Promise<GetQueueJobsResponse>;
};

export const performQueueAction = async (
  action: QueueAction,
  queueName: string,
  jobId?: string,
): Promise<ActionResponse> => {
  const body: Record<string, string> = {
    action,
    queueName,
  };

  if (jobId !== undefined) {
    body.jobId = jobId;
  }

  const response = await fetch(`${BASE_URL}/actions`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Failed to perform action: ${response.statusText}`);
  }

  return response.json() as Promise<ActionResponse>;
};
